// extracted by mini-css-extract-plugin
export default {"wrapper":"AppName_wrapper__5ETOa","appLogo":"AppName_appLogo__w0D3E","appName":"AppName_appName__2QDZN"};